import { ModalEvents } from '@/lib/Modal/ModalEvents';

enum VideoThumbnailEvents {
	ThumbnailSelected = 'thumbnailSelected',
}

type VideoThumbnailEmitters = {
	[VideoThumbnailEvents.ThumbnailSelected]: (val: string | null) => void;
	[ModalEvents.Reveal]: (name: string | null) => void;
	[ModalEvents.Closed]: () => void;
};

export { VideoThumbnailEvents, VideoThumbnailEmitters };
